export const appHead = {"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"mask-icon","href":"/safari-pinned-tab.svg","color":"#daa497"}],"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"google-site-verification","content":"2kVV5Is0ywDOCco5xBQVYSz7lvwuVRvdJBqkVMs_rcA"},{"name":"theme-color","content":"#ffffff"},{"name":"msapplication-TileColor","content":"#120b2b"},{"property":"og:type","content":"website"}],"style":[],"script":[{"src":"https://cdn.rudderlabs.com/v3/modern/rsa.min.js"},{"src":"https://checkout.vipps.no/vippsCheckoutSDK.js","id":"vipps-script-loader"},{"type":"text/javascript","innerHTML":"\nfunction initRudderstack(attempts = 0) {\n  const maxAttempts = 20; // Maximum number of attempts\n  const retryInterval = 500; // 500ms between attempts\n  if (typeof rudderanalytics !== 'undefined' && typeof rudderanalytics.consent === 'function') {\n    // RudderStack is fully loaded, proceed with initialization\n    rudderanalytics.load(\"2alJ0f1uCVi5UXXQJotJmAz4Crj\", \"https://aschehougokk.dataplane.rudderstack.com\", {\n      storage: {\n        type: \"none\"\n      }\n    });\n    \n\n    var pageEventSent = false;\n    var performConsent = function() {\n      rudderanalytics.consent({\n        storage: {\n          type: \"cookieStorage\"\n        },\n        sendPageEvent: !pageEventSent\n      });\n      pageEventSent = true;\n    };\n\n    document.addEventListener(\"cookieyes_banner_load\", function(eventData) {\n      try {\n        if (eventData.detail.categories.analytics) {\n          performConsent();\n        }\n      } catch (error) {\n        console.error(\"Error in cookieyes_banner_load\", error);\n      }\n    });\n\n    document.addEventListener(\"cookieyes_consent_update\", function(eventData) {\n      try {\n        if (eventData.detail.accepted.includes(\"analytics\")) {\n          performConsent();\n        }\n      } catch (error) {\n        console.error(\"Error in cookieyes_consent_update\", error);\n      }\n    });\n\n    // Test event\n    setTimeout(() => {\n      rudderanalytics.track(\"Test Event\");\n    }, 5000);\n\n  } else if (attempts < maxAttempts) {\n    setTimeout(() => initRudderstack(attempts + 1), retryInterval);\n  } else {\n    console.error('RudderStack failed to load after maximum attempts');\n  }\n}\n\n// Start the initialization process\ninitRudderstack();\n\n// Check if RudderStack loaded\nwindow.addEventListener('load', function() {\n  if (typeof rudderanalytics === 'undefined') {\n    console.error('RudderStack failed to load');\n  }\n});\n"}],"noscript":[],"htmlAttrs":{}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = true

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const resetAsyncDataToUndefined = false

export const nuxtDefaultErrorValue = undefined

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = true

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false